var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        "filter-toggle": true,
        open: this.open,
      },
    },
    [
      _c(
        "button",
        {
          class: {
            "filter-toggle__button": true,
            open: this.open,
          },
          on: {
            click: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.toggle.apply(null, arguments)
            },
          },
        },
        [
          _c("span", {
            domProps: {
              textContent: _vm._s(_vm.open ? "Hide Filters" : "Show Filters"),
            },
          }),
          _vm._v(" "),
          _c("svg", [_c("path", { attrs: { d: "M4.95 2L1 7h8L4.95 2z" } })]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "filter-toggle__content" }, [
        _c("div", { staticClass: "toolbar" }, [
          _c("fieldset", { staticClass: "toolbar__filters" }, [
            _c("div", { staticClass: "flex-fix" }, [_vm._t("default")], 2),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }